import '@fontsource-variable/noto-sans-thai/wght.css';
import './styles/app.css';
import './lib/i18n.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './app/App.tsx';
import { PwaProvider } from './lib/pwa.tsx';
import { RouterProvider } from './lib/router.tsx';
import { SessionProvider } from './lib/session.tsx';

// Queries never retry a 4xx (it would fail the same way) and never refetch on an interval by default;
// ETag polling is opted into per screen (ADR-12).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: (n, e) => n < 2 && (e as { status?: number }).status === 0, refetchOnWindowFocus: true, staleTime: 15_000 },
    mutations: { retry: false },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider>
        <PwaProvider>
          <SessionProvider>
            <App />
          </SessionProvider>
        </PwaProvider>
      </RouterProvider>
    </QueryClientProvider>
  </StrictMode>,
);
